<div class="container-fluid" [ngClass]="!theme ? 'dark-theme' : ''">
    <div class="row">
        <div class="col-sm-12 p-0">
            <div class="card mb-0 border-0">
                <div class="card-body p-0">
                    <div class="profile-bg  position-relative">
                        <div class="bg-overlay">
                            <h1 class="txt-blue txt-heading">Redeem Your Code</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-sm-11 profile-wrapper">
            <div class="card sumo-card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-7 border-right left-side-content pr-35">
                            <div class="d-flex align-items-center  mb-1 sum-code-input">
                                <input type="text" class="form-control input w-80" placeholder="Code"[(ngModel)]="codeName">
                                <button type="button" class="btn btn-primary" [disabled]="codeName==''"  (click)="redeemAppSumoCode()">Redeem</button>
                            </div>
                            <div class="d-flex flex-wrap align-items-center" style="height: 150px !important;overflow: auto;">
                                <div class="text-gray rounded-pill d-flex p-2 round-border bg-light-white m-1" *ngFor="let data of sumoCodes">
                                    <span class="fw-600 px-2 fs-12">
                                        {{data}}
                                    </span>
                                </div>
                            </div>
                            
                        </div>
                        <div class="col-sm-5">
                            <h1 class="fw-bold light-neutral txt-black">Available Credits</h1>
                            <div class="border-bottom mb-3 pb-2">
                                <div class="d-flex align-items-center">
                                    <p class="mb-0 detail-left col-8">Audit/Content Editor: {{userData.credit}} / {{userData.max_credit == 'inf' ? 'inf' : userData.max_credit}} </p>
                                    <p class="mb-0 detail-right col-4">{{userData.max_credit == 'inf' ? 'inf' : userData.max_credit - userData.credit}} remaining </p>
                                </div>
                            </div>

                            <div class="border-bottom mb-3 pb-2">
                                <div class="d-flex align-items-center">
                                    <p class="mb-0 detail-left col-8">Keyword Reports: {{userData.kw_credit}} / {{userData.kw_max_credit}}</p>
                                    <p class="mb-0 detail-right col-4">{{userData.kw_max_credit - userData.kw_credit}} remaining </p>
                                </div>
                            </div>

                            <div class="mb-3 pb-2">
                                <div class="d-flex align-items-center">
                                    <p class="mb-0 detail-left col-8">SERP Credits: {{userData.serp_credit}} / {{userData.serp_max_credit}}</p>
                                    <p class="mb-0 detail-right col-4"> {{userData.serp_max_credit - userData.serp_credit}} remaining </p>
                                </div>
                            </div>

                            <!-- <div class="d-flex justify-content-end">
                                <button type="button" class="btn btn-primary">
                                    <img src="assets/images/add.png" alt="" width="16" height="16">
                                    Upgrade Plan</button>
                            </div> -->

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>